import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Sparkles } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(form.email, form.password);
      toast.success("Bienvenue !");
      navigate(u.role === "animateur" ? "/espace-animateur" : u.role === "admin" ? "/admin" : "/mon-compte");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[80vh] grid place-items-center px-4 py-12">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-md bg-white rounded-[2rem] border border-slate-100 shadow-xl p-8 sm:p-10"
      >
        <div className="flex items-center gap-2 mb-6">
          <span className="grid place-items-center w-10 h-10 rounded-2xl bg-sky-500 text-white rotate-[-6deg]">
            <Sparkles className="w-5 h-5" />
          </span>
          <span className="font-heading font-extrabold text-2xl text-slate-900">Kwarizmix</span>
        </div>
        <h1 className="font-heading font-extrabold text-3xl text-slate-900">Connexion</h1>
        <p className="text-slate-500 mt-1 mb-8">Ravis de vous revoir.</p>
        <form onSubmit={submit} className="space-y-4" data-testid="login-form">
          <div>
            <Label>Email</Label>
            <Input required type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="rounded-xl mt-1" data-testid="login-email" />
          </div>
          <div>
            <Label>Mot de passe</Label>
            <Input required type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="rounded-xl mt-1" data-testid="login-password" />
          </div>
          <button
            type="submit"
            disabled={loading}
            data-testid="login-submit"
            className="w-full py-3.5 rounded-full bg-sky-500 text-white font-bold hover:bg-sky-600 hover:scale-[1.02] transition-[transform,background-color] disabled:opacity-60"
          >
            {loading ? "Connexion..." : "Se connecter"}
          </button>
        </form>
        <p className="text-center text-sm text-slate-500 mt-6">
          Pas encore de compte ?{" "}
          <Link to="/inscription" className="text-sky-600 font-bold" data-testid="link-register">
            Inscrivez-vous
          </Link>
        </p>
      </motion.div>
    </div>
  );
}
